import { useEffect } from 'react';

export function useUnmount(delegate: () => void) {
    useEffect(() => {
        return delegate;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
